import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'messages'
const verb = 'get'

export default class OspreyMessagesUniqueName extends BaseAction {
    constructor(dataKey) {
        const id = '1e1ca48a-5d2f-47a1-a720-9fd03b36f3c8'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    getMessagesUniqueName(params) {
        this.params = params

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/messages/messages-unique-name.js